import { FC, SVGProps } from 'react';

const AdvertisementIcon: FC<SVGProps<SVGSVGElement> & { size?: number }> = ({
  color = '#fff',
  size = 20,
  ...props
}) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props} fill="none">
      <path
        d="M6.48513 2.5H13.5141C15.9708 2.5 17.5 4.23432 17.5 6.68865V13.3113C17.5 15.7657 15.9708 17.5 13.5133 17.5H6.48513C4.02837 17.5 2.5 15.7657 2.5 13.3113V6.68865C2.5 4.23432 4.03567 2.5 6.48513 2.5Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.67841 12.6861L7.46821 7.31445L5.25879 12.6861"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.04883 10.7683H8.8885"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.824 7.33337V12.5954C14.824 12.5954 11.6665 13.3699 11.6665 11.0758C11.6665 8.78077 14.824 9.48944 14.824 9.48944"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default AdvertisementIcon;
